import { colors, Typography } from "@material-ui/core"
import React from "react"

interface Props {
    error: string | React.ReactNode | null
}

class GlobalFormError extends React.Component<Props> {
    render() {
        return (
            this.props.error && (
                <Typography variant="body2" style={{ color: colors.red.A200, marginTop: "0.5rem" }} align="center">
                    {this.props.error}
                </Typography>
            )
        )
    }
}

export default GlobalFormError
